import { IActivityItemProps, ICommandBarItemProps, Icon, Link, PanelType, Persona, PersonaSize, TooltipHost, ComboBox, IComboBox, IComboBoxOption, Stack } from '@fluentui/react';
import React, { useContext, useEffect, useImperativeHandle, useState } from "react"
import { IColumn, Selection } from "@fluentui/react/lib/DetailsList";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelPlantillaFiltro } from '../../../components/PanelUpload/PanelPlantillaFiltro';
import { TableBase } from '../../../components/Table/TableBase';
import { IItemComboBaseDTO, ISearch, IException, IReportTelerik } from '../../../interfaces/base/IBase';
import { IDataCollection, IPagination } from '../../../interfaces/base/ITable';
import { IFilterUbicacion } from '../../../interfaces/filter/IFilterUbicacion';
import { IProgramacionPersona, IFilterProgramacion } from '../../../interfaces/IProgramacion';
import ContratoService from '../../../services/contratoService';
import OrganigramaService from '../../../services/organigramaService';
import ProgramacionPersonaService from '../../../services/programacionPersonaService';
import ProgramacionService from '../../../services/ProgramacionService';
import UbicacionService from '../../../services/ubicacionesServices';
import { ProgramacionProps } from '../../../types/ITypes';
import { _initialFilter, _initialPagination, splitExceptionDetail, baseImageUrl, stackTokensHorizontal } from '../../../utils/Helper/helper';
import { IconHelper } from '../../../utils/Helper/iconHelper';
import { roleAdmin, isRoleAccessAll, ROLE_KEY_USER_SOCIO, ROLE_KEY_USER_EMPLEADO } from '../../../utils/Helper/roleHelper';
import { _initialDataCollection } from '../../../utils/Helper/tableHelper';
import { UbicacionHelper } from '../../../utils/Helper/ubicacionHelper';
import ThemeBase from '../../../utils/Theme/themeBase';
import { ActualizarAccesoPersona } from '../actualizarAccesoPersona';
import { LogActividad } from '../logActividad/logActividad';
import { CrearAccesoVuelo } from '../vuelo/panel/crearAccesoVuelo';
import { RetiroMasivoVuelo } from '../vuelo/panel/retiroMasivoVuelo';
import { AuthContext } from '../../../auth/context/auth-context';
import RepoteBase from '../../../components/Generic/ReporteBase';
import RepoteBaseGenerico from '../../../components/Generic/ReporteBaseGenerico';
import { NewAccessPerson } from '../../persona/NewAccessPerson';
import { ColorHelper } from '../../../utils/Helper/colorHelper';

const roleOpcionRetiroMasivo = () => {
    let t = [
        ROLE_KEY_USER_EMPLEADO,
        ROLE_KEY_USER_SOCIO,
    ]

    return roleAdmin().concat(t);
}

const reportByRole = (id: string) => {
    let report: IReportTelerik = {
        reportName: 'MOVProgramadoPersonaHelos.trdx',
        param: {
            programacionId: id,
        }
    }

    return report;
}

export const ListarAccesoHelo = React.forwardRef((props: ProgramacionProps, forwardedRef) => {
    /* Access & Role */
    const { access } = useContext(AuthContext);
    let role = access?.role ?? [];
    let isAdmin = isRoleAccessAll(role, roleAdmin());
    let opcionRetiroMasivo = isRoleAccessAll(role, roleOpcionRetiroMasivo())

    const [hidden, setHidden] = useState(false);

    const [isOpenCrearAcceso, { setTrue: openCrearAcceso, setFalse: dismissCrearAcceso },] = useBoolean(false);
    const [column, setColumn] = useState<IColumn[]>([]);
    const [data, setData] = useState<IDataCollection<IProgramacionPersona>>(_initialDataCollection);
    const [filter, setFilter] = useState<IFilterProgramacion>({
        ..._initialFilter(),
        programacionId: props.programacionId
    })

    /* Panel Aprobar */
    /* const [isOpenValidar, { setTrue: openValidar, setFalse: dismissValidar }] = useBoolean(false); */
    const [isOpenRetiroMasivo, { setTrue: openRetiroMasivo, setFalse: dismissRetiroMasivo },] = useBoolean(false);
    const [isOpenPanelFiltro, { setTrue: openPanelFiltro, setFalse: dismissPanelFiltro },] = useBoolean(false);

    /* Dialog */
    /* const [hideEmailCierre, { toggle: toggleEmailCierre }] = useBoolean(true); */

    /* Loading */
    /* const [isLoadingEmail, { setTrue: loadingEmail, setFalse: dismissLoadingEmail }] = useBoolean(false); */

    /* Panel Actualizar */
    const [selId, setSelId] = useState<string | undefined>(undefined);
    const [isOpenActualizar, { setTrue: openActualizar, setFalse: dismissActualizar },] = useBoolean(false);

    /* Panel Log */
    const [isOpenLog, { setTrue: openLog, setFalse: dismissLog },] = useBoolean(false);

    /* Selection */
    const [sel, setSel] = useState<any[]>([]);

    const selection = new Selection({
        onSelectionChanged: () => {
            let d: any[] = selection.getSelection();

            let t: IActivityItemProps[] = d
                .filter(x => !x.isDisabled)
                .map((x) => {
                    return {
                        key: `id_${x.programacionPersonaId}`,
                        activityDescription: [
                            <Link key={x.programacionPersonaId} className={ThemeBase.activityClass.nameText}>
                                {x.nombres}
                            </Link>,
                            <span key={`2_${x.programacionPersonaId}`}> </span>,
                            <span
                                key={`3_${x.programacionPersonaId}`}
                                className={ThemeBase.activityClass.nameText}
                            >
                            </span>,
                        ],
                        activityIcon: <Icon iconName={'ReminderPerson'} />,
                        timeStamp: `DNI: ${x.nroDOI}`,
                        programacionPersonaId: `${x.programacionPersonaId}`,
                    };
                });

            setSel(t);
        },
        getKey: (item: any) => item.programacionPersonaId
    });

    /* Pagination */
    const [currentPage, setCurrentPage] = useState(_initialPagination().currentPage);
    const [pageSize, setPageSize] = useState(_initialPagination().pageSize);
    const [total, setTotal] = useState(_initialPagination().total);

    const [pager, setPager] = useState<IPagination>({
        ..._initialPagination(),
        onPageChange: (page) => setCurrentPage(page),
        onSizeChange: (pageSize) => setPageSize(pageSize),
    });

    const [gerenciaCombo, setGerenciaCombo] = useState<IItemComboBaseDTO[]>([]);
    const [filterGerencia, setFilterGerencia] = useState<ISearch>({
        search: ""
    });

    const [embarqueCombo, setEmbaqueCombo] = useState<IItemComboBaseDTO[]>([]);
    const [filterEmbarque, setFilterEmbarque] = useState<IFilterUbicacion>({
        tipo: UbicacionHelper.TIPO_ORIGEN
    });

    const [destinoCombo, setDestinoCombo] = useState<IItemComboBaseDTO[]>([]);
    const [filterDestino, setFilterDestino] = useState<IFilterUbicacion>({
        tipo: UbicacionHelper.TIPO_DESTINO,
    });

    const [lugarMovilizacionCombo, setLugarMovilizacionCombo] = useState<IItemComboBaseDTO[]>([]);
    const LugarMovilizacionRef = React.useRef<IComboBox>(null);
    const _openOptionMovilizacion = React.useCallback(() => LugarMovilizacionRef.current?.focus(true), []);
    const [filterMovilizacion, setfilterMovilizacion] = useState<ISearch>(_initialFilter);

    const [centroCostoCombo, setCentroCostoCombo] = useState<IItemComboBaseDTO[]>([]);

    /* Telerik */
    const [isOpenTelerik, { setTrue: openTelerik, setFalse: dismissTelerik }] = useBoolean(false);
    let reportTelerik = reportByRole(props.programacionId as string);

    /* Imperative Hook */
    useImperativeHandle(forwardedRef, () => {
        return {
            filterFromParent: (search = '') => {

                let p = _initialPagination().currentPage;

                let f: IFilterProgramacion = {
                    ..._initialFilter(),
                    programacionId: props.programacionId,
                    skip: (p - 1) * pageSize,
                    take: pageSize,
                    search: search.trim(),
                }

                setFilter(f);
                setCurrentPage(p);
                reloadInitial(f);
            }
        }
    });

    /* Hook */
    useEffect(() => {
        reloadInitial();
    }, []);

    /* Hook Pagination */
    useEffect(() => {
        setPager({
            ...pager,
            currentPage: currentPage,
        });

        if (filter) {
            setFilter({
                ...filter,
                skip: (currentPage - 1) * pageSize,
                take: pageSize,
            });
        }
    }, [currentPage]);

    useEffect(() => {
        setPager({
            ...pager,
            total: total,
        });
    }, [total]);

    useEffect(() => {
        dataGerencia();
        dataUbicacionOrigen();
        dataUbicacionDestino();

    }, [filterGerencia, filterEmbarque, filterDestino]);

    useEffect(() => {
        if (filterMovilizacion.search != null) {
            dataLugarMovilizacion();
        }
    }, [filterMovilizacion]);

    useEffect(() => {
        dataCentroCosto()
    }, []);


    /* Api */
    const dataAccesoHelo = (param = filter) => {
        setData(_initialDataCollection);

        ProgramacionPersonaService.allv2AccesoHelo(param)
            .then((res) => {
                if (res.status == 200) {
                    setData(res.data);
                    setTotal(res.data.total);
                    setHidden(true);
                }
            })
            .catch((e) => {
                alert(splitExceptionDetail(e));
                setHidden(true);
            });
    }

    const dataGerencia = () => {
        setGerenciaCombo([]);
        OrganigramaService.organigramaByTipo('01', filterGerencia)
            .then((res) => {
                if (res.status == 200) {
                    let t: IItemComboBaseDTO[] = res.data;
                    // t.unshift(ItemNoneSelect());

                    setGerenciaCombo(t);
                }
            })
            .catch((e: IException) => {
                alert(splitExceptionDetail(e));
            });
    };

    const dataUbicacionOrigen = () => {

        dataUbicacion(filterEmbarque, setEmbaqueCombo);

    }

    const dataUbicacionDestino = () => {

        dataUbicacion(filterDestino, setDestinoCombo);

    }

    const dataUbicacion = (filtro: any, setCombo: React.Dispatch<React.SetStateAction<any>>) => {
        UbicacionService.ubicacionPorFiltro(filtro)
            .then((res) => {
                setCombo(res.data);

            })
            .catch((e: IException) => {
                console.log(splitExceptionDetail(e));
            });
    };

    const dataLugarMovilizacion = () => {
        ProgramacionService.allLugarMovilizacion()
            .then((res) => {
                setLugarMovilizacionCombo(res.data);
            })
            .catch((e: IException) => {
                alert(splitExceptionDetail(e));
            });
    };

    const dataCentroCosto = () => {
        ContratoService.allCentroCosto()
            .then((res) => {
                setCentroCostoCombo(res.data);
            })
            .catch((e: IException) => {
                alert(splitExceptionDetail(e));
            });
    };


    // const emailCierreData = () => {
    //     loadingEmail();

    //     let t: IEmailHeloValido = {
    //         programacionId: props.programacionId,
    //     }

    //     ProgramacionPersonaService.emailHeloValido(t)
    //         .then((res) => {
    //             if (res.status == 200) {
    //                 toggleEmailCierre();
    //                 dismissLoadingEmail();
    //             }
    //         })
    //         .catch((e) => {
    //             alert(splitExceptionDetail(e));
    //             dismissLoadingEmail();
    //         });
    // }

    /* Function */
    const reloadInitial = (param = filter) => {
        setSel([]);
        setHidden(false);
        setTitleColumn();
        dataAccesoHelo(param);
    }

    const setTitleColumn = () => {
        let col: IColumn[] = [
            {
                key: "column1",
                name: "Foto",
                ariaLabel: "Column operations for File type, Press to sort on File type",
                isIconOnly: true,
                fieldName: "foto",
                minWidth: 45,
                maxWidth: 45,
                onRender: (item: IProgramacionPersona) => (
                    <TooltipHost content={`Foto`}>
                        <Persona
                            text=""
                            size={PersonaSize.size24}
                            imageUrl={baseImageUrl}
                        />
                    </TooltipHost>
                ),
            },
            {
                key: "column2",
                name: "Nombre",
                fieldName: "nombres",
                minWidth: 160,
                maxWidth: 200,
                isRowHeader: true,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                sortAscendingAriaLabel: "Sorted A to Z",
                sortDescendingAriaLabel: "Sorted Z to A",
                data: "string",
                isPadded: true,
                onRender: (item: IProgramacionPersona) => {
                    return (
                        <span
                            style={{
                                fontSize: "90%",
                                textDecorationLine:
                                    item.motivoRetiro == "" ? "none" : "line-through",
                            }}
                        >
                            {item.nombres}
                        </span>
                    );
                },
            },
            {
                key: "column3",
                name: "Identificación",
                fieldName: "nroDOI",
                minWidth: 80,
                maxWidth: 90,
                isResizable: true,
                data: "number",
                isPadded: true,
                onRender: (item: IProgramacionPersona) => {
                    return (
                        <span
                            style={{ fontSize: "95%" }}
                        >{`${item.tipoDocumento} ${item.nroDOI}`}</span>
                    );
                },
            },
            {
                key: 'column4',
                name: 'Nivel',
                fieldName: 'nivel',
                minWidth: 60,
                maxWidth: 60,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'column5',
                name: 'Level',
                fieldName: 'level',
                minWidth: 50,
                maxWidth: 50,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'column6',
                name: 'Gerencia',
                fieldName: 'gerencia',
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                isCollapsible: true,
                data: "number",
            },
            {
                key: 'column7',
                name: 'Empresa Persona',
                fieldName: 'empresa',
                minWidth: 150,
                maxWidth: 150,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                isPadded: true,
            },
            {
                key: 'column8',
                name: 'Empresa Transportista',
                fieldName: 'transporte',
                minWidth: 150,
                maxWidth: 150,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                isPadded: true,
            },
            {
                key: 'column16',
                name: 'Lugar Mov.',
                fieldName: 'lugarMovilizacion',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
            },
            {
                key: "column9",
                name: "Bus",
                fieldName: "requiereTransporte",
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                onRender: (item: IProgramacionPersona) => 
                  <TooltipHost content={`${item.requiereTransporte ? "Requiere" : "No requiere"} Bus`}>
                    <Icon
                      iconName="BusSolid"
                      style={{ cursor: "pointer", color:  item.requiereTransporte ? ColorHelper.SUCCESS : ColorHelper.DANGER }}
                      className={`${ThemeBase.classes.iconFont}`}
                    />
                  </TooltipHost>
                  },
                  {
                key: "column10",
                name: "Vuelo",
                fieldName: "requiereVueloComercial",
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                onRender: (item: IProgramacionPersona) => 
                  <TooltipHost content={`${item.requiereVueloComercial ? "Requiere" : "No requiere"} Vuelo Comercial`}>
                    <Icon
                      iconName="AirPlaneSolid"
                      style={{ cursor: "pointer", color: item.requiereVueloComercial ? ColorHelper.SUCCESS : ColorHelper.DANGER }}
                      className={`${ThemeBase.classes.iconFont}`}
                    />
                  </TooltipHost>
              },
              {
                key: "column11",
                name: "Helo",
                fieldName: "esHelo",
                minWidth: 40,
                maxWidth: 40,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                onRender: (item: IProgramacionPersona) => 
                  <span style={{ fontSize: "95%", ...ThemeBase.justifiedStyle }}>{item.esHelo ? 'Si' : 'No'}</span>
              },
            {
                key: 'column12',
                name: 'Origen',
                fieldName: 'origen',
                minWidth: 100,
                maxWidth: 100,
                isResizable: true,
                isCollapsible: true,
                data: "string",
                isPadded: true,
            },
            {
                key: 'column13',
                name: 'Destino',
                fieldName: 'destino',
                minWidth: 100,
                maxWidth: 100,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
                isPadded: true,
            },
            {
                key: 'column14',
                name: "Turno",
                fieldName: "turno",
                minWidth: 70,
                maxWidth: 90,
                isResizable: true,
                isCollapsible: true,
                data: "string",
            },
            // {
            //     key: "column12",
            //     name: "Clasificación",
            //     fieldName: "clasificacion",
            //     minWidth: 70,
            //     maxWidth: 90,
            //     isResizable: true,
            //     isCollapsible: true,
            //     data: 'string',
            // },
            {
                key: "column15",
                name: "Proceso-Estado",
                fieldName: "nivelActual",
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
            },
            {
                key: 'column17',
                name: 'Centro Costo',
                fieldName: 'centroCosto',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
            },
            {
                key: 'column18',
                name: 'Registrado por',
                fieldName: 'nombreUsuarioRegistra',
                minWidth: 80,
                maxWidth: 80,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
            },
            {
                key: 'column19',
                name: 'Opciones',
                fieldName: 'opciones',
                minWidth: 90,
                maxWidth: 100,
                isResizable: true,
                isCollapsible: true,
                data: 'string',
                onRender: (item: IProgramacionPersona) => (
                    <>
                        <Stack horizontal tokens={stackTokensHorizontal}>
                            {isAdmin &&
                                <TooltipHost content={`Editar`}>
                                    <Icon
                                        iconName={IconHelper.ICON_EDIT.iconProps?.iconName}
                                        style={{ cursor: "pointer" }}
                                        className={ThemeBase.classes.iconFont}
                                        onClick={() => {
                                            setSelId(item.programacionPersonaId);
                                            openActualizar();
                                        }}
                                    />
                                </TooltipHost>
                            }

                            {/* Actividad Log */}
                            <TooltipHost content={`Actividades`}>
                                <Icon
                                    iconName={IconHelper.ICON_INFO.iconProps?.iconName}
                                    style={{ cursor: "pointer" }}
                                    className={`${ThemeBase.classes.iconFont}`}
                                    onClick={() => {
                                        setSelId(item.programacionPersonaId);
                                        openLog();
                                    }}
                                />
                            </TooltipHost>
                        </Stack>
                    </>
                ),
            },
        ];

        setColumn(col);
    }

    const _leftBar = () => {
        const _items: ICommandBarItemProps[] = [
            {
                ...IconHelper.ICON_ADD,
                onClick: openCrearAcceso,
            },
            {
                ...IconHelper.ICON_RELOAD,
                onClick: () => reloadInitial(),
            },
        ];

        if (opcionRetiroMasivo) {
            _items.push(
                {
                    ...IconHelper.ICON_CANCEL,
                    text: 'Retirar',
                    onClick: () => {
                        if (sel.length == 0) {
                            return alert("Debe seleccionar al menos un item");
                        }

                        openRetiroMasivo();
                    },
                },
            )
        }

        // if (isAdmin) {
        //     _items.push(
        //         {
        //             ...IconHelper.ICON_MAIL_CHECK,
        //             text: 'Notificar',
        //             onClick: toggleEmailCierre,
        //         },
        //         {
        //             ...IconHelper.ICON_CHECK,
        //             text: 'Agencia Viaje',
        //             onClick: () => {
        //                 if (sel.length == 0) {
        //                     return alert("Debe seleccionar al menos un item");
        //                 }

        //                 openValidar();
        //             },
        //         },
        //     )
        // }

        return _items;
    };

    const _rightBar = () => {
        const _items: ICommandBarItemProps[] = [
            {
                ...IconHelper.ICON_EXCEL,
                onClick: openTelerik,
            },
            {
                ...IconHelper.ICON_FILTER,
                onClick: () => openPanelFiltro(),
            },
        ];

        return _items;
    };

    const _onChangeComboFiltro = (type: string, event: React.FormEvent<IComboBox>, option?: IComboBoxOption) => {

        if (event != undefined) {
            if (option != undefined) {

                switch (type) {

                    case 'gerencia':
                        setFilter({
                            ...filter,
                            gerenciaId: option.key.toString(),
                        })

                        break;
                    case 'origen':


                        setFilter({
                            ...filter,
                            origenId: option.key.toString()
                        })

                        break;
                    case 'destino':


                        setFilter({
                            ...filter,
                            destinoId: option.key.toString()
                        })

                        break;
                    case 'movilizacion':
                        setFilter({
                            ...filter,
                            lugarMovilizacionId: option.key.toString()
                        })

                        break;
                    case 'centroCosto':
                        setFilter({
                            ...filter,
                            centroCostoId: option.key.toString()
                        })

                        break;

                    default:
                        break;
                }
            }
        }
    };

    const _onKeyUpCombo = (e: React.FormEvent<IComboBox>) => {

        let { id } = e?.target as HTMLInputElement;
        let { value } = e?.target as HTMLInputElement;

        switch (id) {

            case "movilizacion-input":
                _openOptionMovilizacion();

                setfilterMovilizacion({
                    ...filterMovilizacion,
                    search: value
                })

                break;
            default:
                break;
        }
    }

    /* Filter */
    const _buscarFiltro = () => {

        setFilter(filter);
        reloadInitial();
    }

    const _limpiarFiltro = () => {

        let modelClear: IFilterProgramacion = {
            ...filter,
            search: "",
            gerenciaId: "",
            lugarMovilizacionId: "",
            centroCostoId: "",
            origenId: "",
            destinoId: "",

        }
        setFilter(modelClear);
        reloadInitial(modelClear);

    }

    return (
        <>
            <TableBase leftBar={_leftBar()} rigthBar={_rightBar()} column={column} data={data.items} isLoading={!hidden} pagination={pager} style={ThemeBase.notPaddingTableBase} selection={selection}></TableBase>
            {/* <CrearAccesoVuelo programacionId={props.programacionId} isOpen={isOpenCrearAcceso} onDismiss={dismissCrearAcceso} setup={reloadInitial} subTitle={`${data.title} | ${data.subTitle}`} isSubida={props.isSubida}></CrearAccesoVuelo> */}
            <NewAccessPerson programacionId={props.programacionId} isOpen={isOpenCrearAcceso} onDismiss={dismissCrearAcceso} setup={reloadInitial} subTitle={`${data.title} | ${data.subTitle}`} isSubida={data.isSubida} codigoTipoProgramacion={data.codigoTipoProgramacion}></NewAccessPerson>
            {/* <ValidarAccesoVuelo programacionId={props.programacionId} isOpen={isOpenValidar} dismiss={dismissValidar} sel={sel} reloadParent={reloadInitial}></ValidarAccesoVuelo> */}
            <RetiroMasivoVuelo programacionId={props.programacionId} isOpen={isOpenRetiroMasivo} dismiss={dismissRetiroMasivo} sel={sel} reloadParent={reloadInitial}></RetiroMasivoVuelo>

            {/* <DialogBase
                isHidden={hideEmailCierre}
                subTitle={'Al confirmar el envio de notificacion se tomará como confirmado la carga de datos por la Agencia de Viaje'}
                tipo={DialogType.normal}
                toggleHidden={() => {
                    dismissLoadingEmail();
                    toggleEmailCierre();
                }}
                dependency={[]}
                confirm={emailCierreData}
                isDisableConfirm={isLoadingEmail}
            ></DialogBase> */}

            <div id='panelFiltro'>
                <>
                    <PanelPlantillaFiltro
                        textHeader='Filtro'
                        subTextHeader='Elija las condiciones para el filtro personalizado'
                        textBoton='Buscar'
                        textBotonDefault='Limpiar'
                        onclickBoton={_buscarFiltro}
                        onclickBotonDefault={_limpiarFiltro}
                        openPanel={isOpenPanelFiltro}
                        closePanel={dismissPanelFiltro}
                        // onRenderHeader={onRenderHeaderFilter}
                        size={PanelType.medium}
                        disabledBoton={false}
                        estadoBarraEnvio={false}
                        nameIconHeader={"Filter"}
                        nameIconButton={"Search"}
                    >
                        <>

                            <div className="ms-Grid" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                        <ComboBox
                                            label="Gerencia:"
                                            id='gerencia'
                                            options={gerenciaCombo}
                                            // componentRef={comboBoxRef}
                                            // selectedKey={filter?.gerenciaId}
                                            calloutProps={{ directionalHintFixed: true }}
                                            useComboBoxAsMenuWidth
                                            allowFreeform
                                            // multiSelect
                                            onChange={(e, o) => _onChangeComboFiltro("gerencia", e, o)}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                                        <ComboBox
                                            label='Origen (Embarque)'
                                            // componentRef={embarqueRef}
                                            allowFreeform
                                            autoComplete="off"
                                            useComboBoxAsMenuWidth
                                            calloutProps={{ directionalHintFixed: true }}
                                            options={embarqueCombo}
                                            // onKeyUp={_onUpEmbarque}
                                            selectedKey={filter?.origenId}
                                            onChange={(e, o) => _onChangeComboFiltro("origen", e, o)}
                                        // onBlur={_onBlurEmbarque}

                                        />
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                                        <ComboBox
                                            label='Destino (Desembarque)'
                                            // componentRef={campamentoRef}
                                            allowFreeform
                                            autoComplete="off"
                                            useComboBoxAsMenuWidth
                                            calloutProps={{ directionalHintFixed: true }}
                                            // onKeyUp={_onUpCampamento}
                                            options={destinoCombo}
                                            selectedKey={filter?.destinoId}
                                            onChange={(e, o) => _onChangeComboFiltro("destino", e, o)}
                                        // onBlur={_onBlurCampamento}
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6" >
                                        <ComboBox
                                            label="Lugar Movilización:"
                                            id="movilizacion"
                                            options={lugarMovilizacionCombo}
                                            componentRef={LugarMovilizacionRef}
                                            selectedKey={filter?.lugarMovilizacionId}
                                            useComboBoxAsMenuWidth
                                            allowFreeform
                                            // placeholder='Gerencia'
                                            autoComplete='off'
                                            calloutProps={{ directionalHintFixed: true }}
                                            onChange={(e, o) => _onChangeComboFiltro("movilizacion", e, o)}
                                            onKeyUp={_onKeyUpCombo}
                                        // onBlur={() => _onBlurCombo('gerencia')}
                                        />

                                    </div>
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6" >
                                        <ComboBox
                                            label="Centro de Costo:"
                                            id="centroCosto"
                                            options={centroCostoCombo}
                                            // componentRef={comboBoxRef}
                                            selectedKey={filter?.centroCostoId}
                                            calloutProps={{ directionalHintFixed: true }}
                                            useComboBoxAsMenuWidth
                                            allowFreeform
                                            onChange={(e, o) => _onChangeComboFiltro("centroCosto", e, o)}

                                        />
                                    </div>
                                </div>

                            </div>
                        </>
                    </PanelPlantillaFiltro>

                </>

            </div>

            {/* Panel Actualizar */}
            <ActualizarAccesoPersona programacionPersonaId={selId} isOpen={isOpenActualizar} dismiss={dismissActualizar} reloadParent={reloadInitial}></ActualizarAccesoPersona>

            {/* Panel Log */}
            <LogActividad programacionPersonaId={selId} isOpen={isOpenLog} dismiss={dismissLog}></LogActividad>

            {/* Panel - Reporte - Telerik */}
            <RepoteBaseGenerico
                NameReport={reportTelerik.reportName}
                Parameters={reportTelerik.param}
                openTelerik={isOpenTelerik}
                dismissTelerik={dismissTelerik}
            ></RepoteBaseGenerico>
        </>
    )
})